export default function () {
    var forms = Array.from(document.querySelectorAll(".form[data-id]"));

    forms.forEach(function (form, idx) {
        form.addEventListener("freeform-ready", function (event) {
            const freeform = event.target.freeform;
            freeform.addOnSuccessfulAjaxSubmit((evt, form, response) => {
                var returnUrl = form.dataset.returnUrl ?? "";
                window.location.href = returnUrl ? returnUrl : response.returnUrl;
            });
        });
    });
}